<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="API日志管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          
          <el-form-item label="调用单位">
            <el-input v-model="params.ApplyEnterprise" placeholder="请输入调用单位" clearable />
          </el-form-item>
          
           <el-form-item label="调用接口">
            <el-select v-model="params.State" placeholder="请选择调用接口" clearable>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="屏蔽" :value="0"></el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="调用结果">
            <el-select v-model="params.State" placeholder="请选择调用结果" clearable>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="屏蔽" :value="0"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="调用时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.IntegralStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.IntegralEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
          
          <el-table-column prop="ApplyEnterprise" label="调用单位" />
           <el-table-column prop="Applymodal" label="调用模块" />
         
          <el-table-column prop="ApplyTime" label="调用时间" />
                 
                 
          <el-table-column prop="State" width="80px" label="调用结果" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.State == 1">成功</el-tag>
              <el-tag type="danger" v-else>失败</el-tag>
            </template>
          </el-table-column>
           

     <!--       <el-table-column prop="RegisterTime" label="注册时间">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.RegisterTime)}}
          </template>
        </el-table-column> -->
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         SendType: "",
         SendContent: "",
         SendLabel: "",
          State: null,
        },
        Grades: [],
      };
    },
   mounted() {
    this.grade_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Grades = res.Data;
      }
    })
  },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{ApplyEnterprise:"君梦",Applymodal:"",ApplyTime:"2024-08-25 11:29:32",UserName:"junmeng001",State:1},{ApplyEnterprise:"怡亚通",ApplyTime:"2024-08-18 16:22:04",UserName:"yiyatong003",State:1}]});
      })
    },
     
    },
  };
  </script>